import { Component, HostListener, Input, OnInit, inject } from '@angular/core';
import { BrowserCompatibilityService } from '@shared/services/browser-compatibility';
import { CompatibilityType } from '@shared/services/browser-compatibility/compatibility.enum';

@Component({
  selector: 'app-layout-page',
  templateUrl: './layout-page.component.html',
  styleUrls: ['./layout-page.component.scss'],
  standalone: false,
})
export class LayoutPageComponent implements OnInit {
  private readonly compatibilityService = inject(BrowserCompatibilityService);

  @Input()
  public checkBrowser = false;

  /**
   * Ask the user to confirm before a reload.
   */
  @Input()
  public confirmReload = false;

  public compatibility: Promise<CompatibilityType | null> | undefined;

  @HostListener('window:beforeunload')
  onBeforeUnload() {
    return !this.confirmReload;
  }

  ngOnInit() {
    if (this.checkBrowser) {
      this.compatibility = this.compatibilityService.checkBrowserSupport();
    }
  }
}
